import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { SessionMetrics } from '../session-performance/SessionMetrics';
import { SessionTrends } from '../session-performance/SessionTrends';
import { TopExperiencesCard } from '../session-performance/TopExperiencesCard';
import { AnalyticsDashboard } from '../shared/AnalyticsDashboard';

interface SessionPerformanceDashboardProps {
  filters: BaseAnalyticsFilter;
  className?: string;
}

function TrendsCard({ filters }: { filters: BaseAnalyticsFilter }) {
  return <SessionTrends filters={filters} />;
}

export default function SessionPerformanceDashboard({
  filters,
  className = '',
}: SessionPerformanceDashboardProps) {
  return (
    <AnalyticsDashboard
      filters={filters}
      metricsComponent={SessionMetrics}
      cards={[TrendsCard, TopExperiencesCard]}
      className={className}
    />
  );
}
